<template>
  <div class="main_form_box">
    <div class="main_form_body">
      <div class="form_bar">
        <div class="form_bar_search">
          <div class="form_bar_search">
            <span class="select_message margin_left_10 margin_right_10">
              已添加（
              {{ questionnaireBodyInfo.QuestinsNumber }}
              ）道题目
              <span v-if="questionnaireInfo.Type === 1">
                ，总分（
                {{ questionnaireBodyInfo.TotalScore }}
                ）分
              </span>
            </span>
          </div>
        </div>
        <div class="form_bar_btn">
          <div class="condition_item">
            <el-button type="text" @click="goBack()">问卷列表</el-button>
          </div>
          <div class="condition_item">
            <el-button @click="changeFullScreen()">
              <i class="el-icon-full-screen"></i>
              <span v-if="!isFullScreen">全屏</span>
              <span v-if="isFullScreen">退出全屏</span>
            </el-button>
          </div>
          <div class="condition_item">
            <el-button
              type="primary"
              @click="editQuestionnaireBody()"
              size="small"
              :disabled="questionnaireInfo.State !== 0"
            >
              保存
            </el-button>
          </div>
        </div>
      </div>
      <div
        id="questionnaireElementBox"
        class="form_content"
        style="min-height: 500px; padding: 0px 15px; margin: 0px 0px 50px 0px"
      >
        <el-empty
          description="暂无内容"
          v-show="questionnaireBodyInfo.QuestionnaireElements.length === 0"
        >
          <el-popover placement="bottom" v-model="popoverVisible">
            <div class="popover_operate_box">
              <el-button
                size="mini"
                type="primary"
                plain
                @click="openEditElementQuestion(null, -1, 'add', 1)"
              >
                单选
              </el-button>
              <el-button
                size="mini"
                type="primary"
                plain
                @click="openEditElementQuestion(null, -1, 'add', 2)"
              >
                多选
              </el-button>
              <el-button
                size="mini"
                type="primary"
                plain
                @click="openEditElementQuestion(null, -1, 'add', 3)"
              >
                判断
              </el-button>
              <el-button
                size="mini"
                type="primary"
                plain
                @click="openEditElementQuestion(null, -1, 'add', 4)"
              >
                填空
              </el-button>
              <el-button
                size="mini"
                type="primary"
                plain
                @click="openEditElementQuestion(null, -1, 'add', 5)"
              >
                问答
              </el-button>
              <el-button
                size="mini"
                type="primary"
                plain
                @click="openEditElementQuestion(null, -1, 'add', 6)"
              >
                附件
              </el-button>
            </div>
            <div class="popover_operate_box">
              <el-button
                size="mini"
                type="primary"
                plain
                @click="openEditElementTitle(null, -1, 'add')"
              >
                章节
              </el-button>
              <el-button
                size="mini"
                type="primary"
                plain
                @click="openEditRandomQuestion(null, -1, 'add')"
              >
                随机选题
              </el-button>
              <el-button
                size="mini"
                type="primary"
                plain
                @click="openBatchAdd(-1)"
              >
                批量添加
              </el-button>
              <el-button size="mini" type="primary" plain>
                Excel上传
              </el-button>
            </div>
            <el-link type="primary" slot="reference">添加</el-link>
          </el-popover>
        </el-empty>
        <div
          class="div_element_box div_element_box_border"
          v-for="(
            element, index
          ) in questionnaireBodyInfo.QuestionnaireElements"
          :key="index"
          @mousemove="mouseoverIndex = index"
          @mouseout="mouseoverIndex = -1"
        >
          <div class="div_element">
            <div
              class="div_element_title_all div_element_title_duanluo"
              v-if="element.ElementType === 1"
            >
              <span class="show_index">{{ element.showIndex }}</span>
              <div v-html="element.Title"></div>
            </div>

            <div
              class="div_element_title_all div_element_title_question_16"
              v-if="element.ElementType === 2"
            >
              <span class="show_index">{{ element.showIndex }}</span>
              <div
                class="div_element_title"
                v-if="questionnaireInfo.Type === 1"
                v-html="
                  '<span class=\'element_score\'>（' +
                  element.Score +
                  '分）</span>' +
                  '<span class=\'element_type\'>【' +
                  element.QuestionTypeText +
                  '】</span>' +
                  element.QuestionStem
                "
              ></div>
              <div
                class="div_element_title"
                v-if="questionnaireInfo.Type !== 1"
                v-html="
                  '<span class=\'element_type\'>【' +
                  element.QuestionTypeText +
                  '】</span>' +
                  element.QuestionStem
                "
              ></div>
            </div>
            <div class="div_element_option_box">
              <div
                class="div_element_option_item"
                v-for="(optionItem, optionIndex) in element.OptionItems"
                :key="optionIndex"
              >
                <i
                  class="iconfont icon-duoxuan-yixuanze div_element_option_item_right"
                  v-if="
                    optionItem.IsRight &&
                    (element.QuestionType === 1 ||
                      element.QuestionType === 2 ||
                      element.QuestionType === 3)
                  "
                ></i>
                <i
                  class="iconfont icon-32duoxuanweixuanzhong"
                  v-if="
                    !optionItem.IsRight &&
                    (element.QuestionType === 1 ||
                      element.QuestionType === 2 ||
                      element.QuestionType === 3)
                  "
                ></i>
                <span class="div_element_option_item_index">
                  {{
                    getOptionIndex(
                      questionnaireInfo.OptionSerialNumberType,
                      element.QuestionType,
                      optionIndex
                    )
                  }}
                </span>
                <div
                  class="div_element_option_item_content"
                  v-html="optionItem.Content"
                  v-if="
                    element.QuestionType === 1 ||
                    element.QuestionType === 2 ||
                    element.QuestionType === 3
                  "
                ></div>
                <div
                  class="blank_right_answers_tag_box"
                  v-if="
                    element.QuestionType === 4 && questionnaireInfo.Type !== 2
                  "
                >
                  <div
                    v-for="(rightItem, rightItemIndex) in JSON.parse(
                      optionItem.Content
                    )"
                    :key="index + optionIndex + rightItemIndex + 'rightItem'"
                    class="blank_right_answers_tag_item"
                  >
                    <el-tag effect="plain" v-show="rightItem.Answer">
                      {{ rightItem.Answer }}
                    </el-tag>
                    <span
                      v-if="
                        rightItemIndex <
                        JSON.parse(optionItem.Content).length - 1
                      "
                    >
                      或
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="element.ElementType === 3">
              <div class="div_element_title_all div_element_title_question_16">
                <span class="show_index">{{ element.showIndex }}</span>
                【随机题目】
              </div>
              从以下题库：
              <ul>
                <li
                  v-for="(
                    groupItem, groupIndex
                  ) in element.RandomQuestionGroups"
                  :key="groupIndex"
                >
                  {{ groupItem.Name }}
                </li>
              </ul>
              <div style="margin: 10px 0px 0px 0px">
                随机抽取
                {{ element.RandomCondition.Single.QuestionNum }}
                个 <b>单选题</b>，每题
                <b>{{ element.RandomCondition.Single.QuestionScore }}</b> 分
              </div>
              <div style="margin: 10px 0px 0px 0px">
                随机抽取
                {{ element.RandomCondition.Multiple.QuestionNum }}
                个 <b>多选题</b>，每题
                <b>{{ element.RandomCondition.Multiple.QuestionScore }}</b> 分
              </div>
              <div style="margin: 10px 0px 0px 0px">
                随机抽取
                {{ element.RandomCondition.TrueOrFalse.QuestionNum }}
                个 <b>判断题</b>，每题
                <b>{{ element.RandomCondition.TrueOrFalse.QuestionScore }}</b>
                分
              </div>
              <div style="margin: 10px 0px 0px 0px">
                随机抽取
                {{ element.RandomCondition.Blank.QuestionNum }}
                个 <b>填空题</b>，每题
                <b>{{ element.RandomCondition.Blank.QuestionScore }}</b> 分
              </div>
              <div style="margin: 10px 0px 0px 0px">
                随机抽取
                {{ element.RandomCondition.QA.QuestionNum }}
                个 <b>问答题</b>，每题
                <b>{{ element.RandomCondition.QA.QuestionScore }}</b> 分
              </div>
            </div>

            <div class="div_element_oparea">
              <div
                v-show="mouseoverIndex === index"
                v-if="questionnaireInfo.State === 0"
              >
                <el-popover placement="bottom-start">
                  <div class="popover_operate_box">
                    <el-button
                      size="mini"
                      type="primary"
                      plain
                      @click="openEditElementQuestion(null, index, 'add', 1)"
                    >
                      单选
                    </el-button>
                    <el-button
                      size="mini"
                      type="primary"
                      plain
                      @click="openEditElementQuestion(null, index, 'add', 2)"
                    >
                      多选
                    </el-button>
                    <el-button
                      size="mini"
                      type="primary"
                      plain
                      @click="openEditElementQuestion(null, index, 'add', 3)"
                    >
                      判断
                    </el-button>
                    <el-button
                      size="mini"
                      type="primary"
                      plain
                      @click="openEditElementQuestion(null, index, 'add', 4)"
                    >
                      填空
                    </el-button>
                    <el-button
                      size="mini"
                      type="primary"
                      plain
                      @click="openEditElementQuestion(null, index, 'add', 5)"
                    >
                      问答
                    </el-button>
                    <el-button
                      size="mini"
                      type="primary"
                      plain
                      @click="openEditElementQuestion(null, index, 'add', 6)"
                    >
                      附件
                    </el-button>
                  </div>
                  <div class="popover_operate_box">
                    <el-button
                      size="mini"
                      type="primary"
                      plain
                      @click="openEditElementTitle(null, index, 'add')"
                    >
                      章节
                    </el-button>
                    <el-button
                      size="mini"
                      type="primary"
                      plain
                      @click="openEditRandomQuestion(null, index, 'add')"
                    >
                      随机选题
                    </el-button>
                    <el-button
                      size="mini"
                      type="primary"
                      plain
                      @click="openBatchAdd(index)"
                    >
                      批量添加
                    </el-button>
                    <el-button size="mini" type="primary" plain>
                      Excel上传
                    </el-button>
                  </div>
                  <el-link type="primary" slot="reference">该项后插入</el-link>
                </el-popover>
              </div>
              <div
                v-show="mouseoverIndex === index"
                v-if="questionnaireInfo.State === 0"
              >
                <el-button
                  icon="el-icon-edit"
                  size="mini"
                  @click="editElement(element, index, 'edit')"
                >
                  编辑
                </el-button>
                <el-button
                  icon="el-icon-delete"
                  size="mini"
                  @click="deleteElement(element, index)"
                >
                  删除
                </el-button>
                <el-button
                  icon="el-icon-top"
                  size="mini"
                  @click="moveUpElement(element, index)"
                >
                  上移
                </el-button>
                <el-button
                  icon="el-icon-bottom"
                  size="mini"
                  @click="moveDownElement(element, index)"
                >
                  下移
                </el-button>
                <el-button
                  icon="el-icon-upload2"
                  size="mini"
                  @click="moveFirstElement(element, index)"
                >
                  最前
                </el-button>
                <el-button
                  icon="el-icon-download"
                  size="mini"
                  @click="moveLastElement(element, index)"
                >
                  最后
                </el-button>
              </div>
              <div
                v-show="mouseoverIndex === index"
                v-if="questionnaireInfo.State === 1"
              ></div>
              <div
                v-show="mouseoverIndex === index"
                v-if="
                  questionnaireInfo.State === 1 && element.ElementType !== 3
                "
              >
                <el-button
                  icon="el-icon-edit"
                  size="mini"
                  @click="editPublishElement(element, index, 'edit')"
                >
                  编辑
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <EditElementTitle
        :fatherSubmitDialog="editElementDialog"
        ref="editElementTitle"
      ></EditElementTitle>
      <EditElementQuestion
        :fatherSubmitDialog="editElementDialog"
        ref="editElementQuestion"
      ></EditElementQuestion>
      <EditElementRandomQuestion
        :fatherSubmitDialog="editElementDialog"
        ref="editElementRandomQuestion"
      ></EditElementRandomQuestion>
      <BatchAdd
        :fatherSubmitDialog="batchAddElementDialog"
        ref="batchAdd"
      ></BatchAdd>
      <EditPublisElementTitle
        :fatherSubmitDialog="editPublishElementDialog"
        ref="editPublishElementTitle"
      ></EditPublisElementTitle>
      <EditPublishElementQuestion
        :fatherSubmitDialog="editPublishElementDialog"
        ref="editPublishElementQuestion"
      ></EditPublishElementQuestion>
    </div>
  </div>
</template>
<script>
import questionnaireApi from '../../../api/wj/questionnaire'
import EditElementTitle from '@/components/wj/EditElementTitle.vue'
import EditElementQuestion from '@/components/wj/EditElementQuestion.vue'
import EditElementRandomQuestion from '@/components/wj/EditElementRandomQuestion.vue'
import BatchAdd from '@/components/wj/BatchAdd.vue'
import EditPublisElementTitle from '@/components/wj/EditPublisElementTitle.vue'
import EditPublishElementQuestion from '@/components/wj/EditPublishElementQuestion.vue'
export default {
  name: 'editBody',
  components: {
    EditElementTitle,
    EditElementQuestion,
    EditElementRandomQuestion,
    BatchAdd,
    EditPublisElementTitle,
    EditPublishElementQuestion
  },
  data () {
    return {
      meetingId: null,
      isFullScreen: false,
      popoverVisible: false,
      questionnaireBodyInfo: {
        QuestionnaireElements: []
      },
      initItem: {
        Id: null,
        QuestionnaireId: null,
        ElementType: 1,
        Title: null,
        RandomCondition: null,
        RandomQuestionGroups: [],
        QuestionId: null,
        QuestionType: null,
        QuestionStem: null,
        Score: null,
        TextHeight: null,
        TextWidth: null,
        MinWordNum: null,
        MaxWordNum: null,
        TextValidation: null,
        OptionItems: []
      },
      mouseoverIndex: -1,
      isQuestionnaireChange: false
    }
  },
  props: ['voteInfo', 'meetingInfo', 'questionnaireInfo'],
  inject: ['voteCheck', 'getVoteInfo', 'getQuestionnaireInfo', 'routeChange', 'switchFullScreen'],
  methods: {
    goBack: function () {
      this.$router.push({ name: 'questionnaireManage', params: { mid: this.$route.params.mid } })
    },
    changeFullScreen: function () {
      const _this = this
      _this.isFullScreen = !_this.isFullScreen
      _this.switchFullScreen()
    },
    getQuestionnaireBodyInfo: function () {
      const _this = this
      const openLoading = this.openLoading()
      questionnaireApi.getQuestionnaireBodyInfo({
        questionnaireId: _this.$route.params.qid
      }).then(data => {
        _this.questionnaireBodyInfo = data
        _this.setElement()
        openLoading.close()
      }).catch(err => {
        openLoading.close()
        return err
      })
    },
    editQuestionnaireBody: function () {
      const _this = this
      const openLoading = this.openLoading()
      questionnaireApi.editQuestionnaireBody(_this.questionnaireBodyInfo).then(data => {
        _this.getQuestionnaireBodyInfo()
        _this.voteCheck()
        _this.$message({
          showClose: true,
          type: 'success',
          message: '保存成功!',
          customClass: 'custom_message'
        })
        _this.isQuestionnaireChange = false
        openLoading.close()
      }).catch(err => {
        openLoading.close()
        return err
      })
    },
    openEditElementTitle: function (item, index, action) {
      const _this = this
      let elementItem = {}
      if (action === 'add') {
        elementItem = JSON.parse(JSON.stringify(_this.initItem))
        elementItem.Id = null
        elementItem.QuestionnaireId = _this.$route.params.qid
        elementItem.ElementType = 1
        elementItem.Title = null
      } else {
        elementItem = JSON.parse(JSON.stringify(item))
      }
      this.$refs.editElementTitle.openEditElementTitle(elementItem, index, action)
    },
    editElementDialog: function (elementItem, index, action) {
      const _this = this
      const openLoading = this.openLoading()
      let questionTypeText = ''
      if (elementItem.ElementType === 2) {
        switch (elementItem.QuestionType) {
          case 1:
            questionTypeText = '单选'
            break
          case 2:
            questionTypeText = '多选'
            break
          case 3:
            questionTypeText = '判断'
            break
          case 4:
            questionTypeText = '填空'
            break
          case 5:
            questionTypeText = '问答'
            break
          case 6:
            questionTypeText = '附件'
            break
        }
      }
      if (action === 'add') {
        _this.questionnaireBodyInfo.QuestionnaireElements.splice(index + 1, 0, JSON.parse(JSON.stringify(elementItem)))
        _this.$set(_this.questionnaireBodyInfo.QuestionnaireElements[index + 1], 'QuestionTypeText', questionTypeText)
      } else {
        _this.questionnaireBodyInfo.QuestionnaireElements.splice(index, 1, JSON.parse(JSON.stringify(elementItem)))
        _this.$set(_this.questionnaireBodyInfo.QuestionnaireElements[index], 'QuestionTypeText', questionTypeText)
      }

      _this.setElement()
      _this.isQuestionnaireChange = true
      openLoading.close()
    },
    openEditElementQuestion: function (item, index, action, questonType) {
      const _this = this
      let elementItem = {}
      if (action === 'add') {
        elementItem = JSON.parse(JSON.stringify(_this.initItem))
        elementItem.Id = null
        elementItem.QuestionnaireId = _this.$route.params.qid
        elementItem.ElementType = 2
        elementItem.QuestionType = questonType
      } else {
        elementItem = JSON.parse(JSON.stringify(item))
      }
      this.$refs.editElementQuestion.openEditElementQuestion(elementItem, index, action)
    },
    openEditRandomQuestion: function (item, index, action) {
      const _this = this
      let elementItem = {}
      if (action === 'add') {
        elementItem = JSON.parse(JSON.stringify(_this.initItem))
        elementItem.Id = null
        elementItem.QuestionnaireId = _this.$route.params.qid
        elementItem.ElementType = 3
        elementItem.RandomCondition = {
          QuestionGroupIds: [],
          Single: { QuestionNum: 0, QuestionScore: 0 },
          Multiple: { QuestionNum: 0, QuestionScore: 0 },
          TrueOrFalse: { QuestionNum: 0, QuestionScore: 0 },
          Blank: { QuestionNum: 0, QuestionScore: 0 },
          QA: { QuestionNum: 0, QuestionScore: 0 }
        }
        elementItem.RandomQuestionGroups = []
      } else {
        elementItem = JSON.parse(JSON.stringify(item))
      }
      this.$refs.editElementRandomQuestion.openEditRandomQuestion(elementItem, index, action, _this.meetingInfo.CompanyID)
    },
    editElement: function (item, index, action) {
      const _this = this
      if (item.ElementType === 1) {
        const elementItem = JSON.parse(JSON.stringify(item))
        _this.$refs.editElementTitle.openEditElementTitle(elementItem, index, action)
      }
      if (item.ElementType === 2) {
        const elementItem = JSON.parse(JSON.stringify(item))
        _this.$refs.editElementQuestion.openEditElementQuestion(elementItem, index, action)
      }
      if (item.ElementType === 3) {
        const elementItem = JSON.parse(JSON.stringify(item))
        _this.$refs.editElementRandomQuestion.openEditRandomQuestion(elementItem, index, action, _this.meetingInfo.CompanyID)
      }
    },
    editPublishElement: function (item, index, action) {
      const _this = this
      if (item.ElementType === 1) {
        const elementItem = JSON.parse(JSON.stringify(item))
        _this.$refs.editPublishElementTitle.openEditElementTitle(elementItem)
      }
      if (item.ElementType === 2) {
        const elementItem = JSON.parse(JSON.stringify(item))
        _this.$refs.editPublishElementQuestion.openEditElementQuestion(elementItem)
      }
    },
    editPublishElementDialog: function () {
      const _this = this
      _this.getQuestionnaireBodyInfo()
    },
    openBatchAdd: function (index) {
      const _this = this
      _this.$refs.batchAdd.openBatchAdd(index, _this.meetingInfo.CompanyID)
    },
    batchAddElementDialog: function (items, index) {
      const _this = this
      const openLoading = _this.openLoading()
      items.forEach(function (element, newElementIndex) {
        _this.questionnaireBodyInfo.QuestionnaireElements.splice(index + 1 + newElementIndex, 0, JSON.parse(JSON.stringify(element)))
        let questionTypeText = ''
        if (element.ElementType === 2) {
          switch (element.QuestionType) {
            case 1:
              questionTypeText = '单选'
              break
            case 2:
              questionTypeText = '多选'
              break
            case 3:
              questionTypeText = '判断'
              break
            case 4:
              questionTypeText = '填空'
              break
            case 5:
              questionTypeText = '问答'
              break
            case 6:
              questionTypeText = '附件'
              break
          }
        }
        _this.$set(_this.questionnaireBodyInfo.QuestionnaireElements[index + 1 + newElementIndex], 'QuestionTypeText', questionTypeText)
      })

      _this.setElement()
      _this.isQuestionnaireChange = true
      openLoading.close()
    },
    deleteElement: function (item, index) {
      const _this = this
      _this.$confirm('确认删除该选项吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'custom_message_box',
        dangerouslyUseHTMLString: true
      }).then(() => {
        const openLoading = this.openLoading()
        _this.questionnaireBodyInfo.QuestionnaireElements.splice(index, 1)
        _this.setElement()
        _this.isQuestionnaireChange = true
        openLoading.close()
      }).catch(() => {
        _this.$message({
          type: 'info',
          message: '已取消删除',
          customClass: 'custom_message'
        })
      })
    },
    moveUpElement: function (item, index) {
      const _this = this
      const openLoading = this.openLoading()
      if (index > 0) {
        _this.questionnaireBodyInfo.QuestionnaireElements.splice(index, 1)
        _this.questionnaireBodyInfo.QuestionnaireElements.splice(index - 1, 0, item)
        _this.setElement()
        _this.isQuestionnaireChange = true
      } else {
        _this.$message({
          type: 'info',
          message: '已经是第一条数据',
          customClass: 'custom_message'
        })
      }
      openLoading.close()
    },
    moveDownElement: function (item, index) {
      const _this = this
      const openLoading = this.openLoading()
      if (index < _this.questionnaireBodyInfo.QuestionnaireElements.length - 1) {
        _this.questionnaireBodyInfo.QuestionnaireElements.splice(index, 1)
        _this.questionnaireBodyInfo.QuestionnaireElements.splice(index + 1, 0, item)
        _this.setElement()
        _this.isQuestionnaireChange = true
      } else {
        _this.$message({
          type: 'info',
          message: '已经是最后一条数据',
          customClass: 'custom_message'
        })
      }
      openLoading.close()
    },
    moveFirstElement: function (item, index) {
      const _this = this
      const openLoading = this.openLoading()
      if (index !== 0) {
        _this.questionnaireBodyInfo.QuestionnaireElements.splice(index, 1)
        _this.questionnaireBodyInfo.QuestionnaireElements.splice(0, 0, item)
        _this.setElement()
        _this.isQuestionnaireChange = true
      } else {
        _this.$message({
          type: 'info',
          message: '已经是第一条数据',
          customClass: 'custom_message'
        })
      }
      openLoading.close()
    },
    moveLastElement: function (item, index) {
      const _this = this
      const openLoading = this.openLoading()
      if (index !== _this.questionnaireBodyInfo.QuestionnaireElements.length - 1) {
        _this.questionnaireBodyInfo.QuestionnaireElements.splice(index, 1)
        _this.questionnaireBodyInfo.QuestionnaireElements.splice(_this.questionnaireBodyInfo.QuestionnaireElements.length, 0, item)
        _this.setElement()
        _this.isQuestionnaireChange = true
      } else {
        _this.$message({
          type: 'info',
          message: '已经是最后一条数据',
          customClass: 'custom_message'
        })
      }
      openLoading.close()
    },
    setElement () {
      const _this = this
      let duanluoIndex = 1
      let questionIndex = 1
      let questionNum = 0
      let questionTotalScore = 0
      _this.questionnaireBodyInfo.QuestionnaireElements.forEach(function (element, index) {
        if (element.ElementType === 1) {
          _this.$set(element, 'showIndex', _this.changeNumToHan(duanluoIndex) + '、')
          duanluoIndex++
        }
        if (element.ElementType === 2) {
          _this.$set(element, 'showIndex', questionIndex + '.')
          questionIndex++

          questionNum += 1
          questionTotalScore += element.Score
        }
        if (element.ElementType === 3) {
          _this.$set(element, 'showIndex', questionIndex + '.')
          questionIndex++

          questionNum += element.RandomCondition.Single.QuestionNum + element.RandomCondition.Multiple.QuestionNum + element.RandomCondition.TrueOrFalse.QuestionNum +
            element.RandomCondition.Blank.QuestionNum + element.RandomCondition.QA.QuestionNum
          if (element.RandomCondition.Single.QuestionScore) {
            questionTotalScore += element.RandomCondition.Single.QuestionNum * element.RandomCondition.Single.QuestionScore
          }
          if (element.RandomCondition.Multiple.QuestionScore) {
            questionTotalScore += element.RandomCondition.Multiple.QuestionNum * element.RandomCondition.Multiple.QuestionScore
          }
          if (element.RandomCondition.TrueOrFalse.QuestionScore) {
            questionTotalScore += element.RandomCondition.TrueOrFalse.QuestionNum * element.RandomCondition.TrueOrFalse.QuestionScore
          }
          if (element.RandomCondition.Blank.QuestionScore) {
            questionTotalScore += element.RandomCondition.Blank.QuestionNum * element.RandomCondition.Blank.QuestionScore
          }
          if (element.RandomCondition.QA.QuestionScore) {
            questionTotalScore += element.RandomCondition.QA.QuestionNum * element.RandomCondition.QA.QuestionScore
          }
        }
      })
      _this.questionnaireBodyInfo.QuestinsNumber = questionNum
      _this.questionnaireBodyInfo.TotalScore = questionTotalScore
    },
    changeNumToHan (num) {
      const arr1 = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
      const arr2 = ['', '十', '百', '千', '万', '十', '百', '千', '亿', '十', '百', '千', '万', '十', '百', '千', '亿']
      if (!num || isNaN(num)) return '零'
      const english = num.toString().split('')
      let result = ''
      for (let i = 0; i < english.length; i++) {
        const desi = english.length - 1 - i// 倒序排列设值
        result = arr2[i] + result
        const arr1Index = english[desi]
        result = arr1[arr1Index] + result
      }
      result = result.replace(/零(千|百|十)/g, '零').replace(/十零/g, '十') // 将【零千、零百】换成【零】 【十零】换成【十】
      result = result.replace(/零+/g, '零') // 合并中间多个零为一个零
      result = result.replace(/零亿/g, '亿').replace(/零万/g, '万') // 将【零亿】换成【亿】【零万】换成【万】
      result = result.replace(/亿万/g, '亿') // 将【亿万】换成【亿】
      result = result.replace(/零+$/, '') // 移除末尾的零
      // 将【一十】换成【十】
      result = result.replace(/^一十/g, '十')
      return result
    },
    getOptionIndex: function (optionSerialNumberType, questionType, optionIndex) {
      if (questionType === 4 && this.questionnaireInfo.Type === 1) {
        return '填空' + (1 + optionIndex) + '：'
      } if (questionType === 1 || questionType === 2 || questionType === 3) {
        if (optionSerialNumberType === 2) {
          return String.fromCharCode(65 + optionIndex) + '、'
        } else if (optionSerialNumberType === 3) {
          return String.fromCharCode(65 + optionIndex).toLowerCase() + '、'
        } else {
          return optionIndex + 1 + '、'
        }
      }
    }
  },
  computed: {

  },
  created () {
    this.meetingId = this.$route.params.mid
    this.initItem.QuestionnaireId = this.$route.params.qid
    this.getQuestionnaireInfo()
    this.getQuestionnaireBodyInfo()
    this.routeChange()
    this.voteCheck()
  },
  beforeRouteLeave (to, from, next) {
    const _this = this
    if (_this.isQuestionnaireChange) {
      _this.$confirm('问卷有未保存的更改，是否保存更改内容', '提示', {
        confirmButtonText: '保存',
        cancelButtonText: '直接离开',
        customClass: 'custom_message_box',
        dangerouslyUseHTMLString: true,
        showClose: false,
        closeOnClickModal: false
      }).then(() => {
        _this.editQuestionnaireBody()
        _this.routeChange()
      }).catch(() => {
        next()
      })
    } else {
      next()
    }
  }
}
</script>
<style lang="less">
#questionnaireElementBox p {
  margin: 0px;
}
.blank_right_answers_tag_box {
  display: -webkit-flex;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
.blank_right_answers_tag_item {
  padding: 0px 0px 8px 0px;
}
.blank_right_answers_tag_item span {
  padding: 0px 8px;
}
</style>
